import React, { FC, useCallback } from 'react';
import { Link } from 'react-router-dom';

// Import Styles
import styled from 'styled-components';
import colors from '../../config/colors';
import SubHeading from '../Headings/SubHeading';
import H2 from '../Headings/H2';
import BackLink from '../LinksStyle/BackLink';
import Label from '../Inputs/Label';
// Messages
import Button from '../ButtonsStyle/index';
import FormInput from '../Inputs/Input';
import { LoadOverlayFadingCircle } from '../Animations';
import Select from '../Inputs/Select';
import history from '../../utils/history';
import BackButton from '../ButtonsStyle/BackButton';
import ListBox from '../CheckboxSelect';

interface Options {
  filter: boolean;
  headerText?: any;
  onChangeFilter?: any;
  optionsFilter?: any;
  selectValue?: string;
  defaultOption?: string;
  defaultOptionText?: string;
  defaultOptionOriginal?: string;
  labelFirstFilter?: string;
  onChangeFilterSecond?: any;
  optionsFilterSecond?: any;
  selectSecondValue?: string;
  defaultOptionSecond?: string;
  defaultOptionTextSecond?: string;
  labelSecondFilter?: string;
  labelThirdFilter?: string;
  ctaButton?: boolean;
  route?: any;
  linkText?: any;
  linkIcon?: any;
  backLink?: any;
  stats?: boolean;
  statsLink?: any;
  statsLinkText?: any;
  statsOpen?: any;
  search?: boolean;
  secondSearch?: boolean;
  thirdSearch?: boolean;
  defaultValueSearch?: string;
  inputPlaceHolderSearch?: string;
  onInputChangeSearch?: any;
  secondFilter?: boolean;
  secondDefaultValueSearch?: string;
  secondInputPlaceHolderSearch?: string;
  secondOnInputChangeSearch?: any;
  thirdFilter?: boolean;
  thirdDefaultValueSearch?: string;
  thirdInputPlaceHolderSearch?: string;
  thirdOnInputChangeSearch?: any;
  loading?: any;
  openSidebar?: boolean;
  sidebarButtonText?: string;
  openSidebarAction?: any;
  sidebarCreate?: boolean;
  sidebarTaskStatus?: boolean;
  sidebarComment?: () => void;
  goBack?: boolean;
  citiesFilter?: boolean;
  cityOptions?: any;
  selectCityValue?: any;
  onChangeCities?: any;
}

const DashboardHeadingFilterSection: FC<Options> = ({
  filter,
  headerText,
  onChangeFilter,
  optionsFilter,
  defaultOption,
  defaultOptionText,
  defaultOptionOriginal,
  selectValue,
  labelFirstFilter,
  selectSecondValue,
  secondFilter,
  onChangeFilterSecond,
  optionsFilterSecond,
  defaultOptionSecond,
  defaultOptionTextSecond,
  labelSecondFilter,
  labelThirdFilter,
  ctaButton,
  route,
  linkText,
  linkIcon,
  backLink,
  stats,
  statsLink,
  statsLinkText,
  statsOpen,
  search,
  defaultValueSearch,
  inputPlaceHolderSearch,
  onInputChangeSearch,
  secondSearch,
  secondDefaultValueSearch,
  secondInputPlaceHolderSearch,
  secondOnInputChangeSearch,
  thirdSearch,
  thirdDefaultValueSearch,
  thirdInputPlaceHolderSearch,
  thirdOnInputChangeSearch,
  loading,
  openSidebar,
  sidebarButtonText,
  openSidebarAction,
  sidebarCreate,
  sidebarTaskStatus,
  goBack,
  sidebarComment,
  citiesFilter,
  cityOptions,
  selectCityValue,
  onChangeCities,
}) => {
  const handleOnChangeCities = useCallback(
    (value: any) => {
      return onChangeCities(value);
    },
    [onChangeCities]
  );

  const onChange = useCallback(
    (value: any) => {
      return onChangeFilter(value);
    },
    [onChangeFilter]
  );

  const onChangeSecond = useCallback(
    (value: any) => {
      return onChangeFilterSecond(value);
    },
    [onChangeFilterSecond]
  );

  const onClickChange = useCallback(
    (e) => {
      statsLink(statsOpen ? false : true);
    },
    [statsLink, statsOpen]
  );

  return (
    <CandidateAppsHeadingSection className="filter-select">
      <span className="filter-select__title">
        {backLink ? (
          <BackLink to={backLink}>
            <svg>
              <use xlinkHref={`#arrow-left`} />
            </svg>
          </BackLink>
        ) : null}
        {goBack ? (
          <BackButton onClick={() => history.goBack()}>
            <svg>
              <use xlinkHref={`#arrow-left`} />
            </svg>
          </BackButton>
        ) : null}
        <H2>
          {headerText}
          {loading ? <LoadOverlayFadingCircle /> : null}
        </H2>
        {stats ? (
          <Stats>
            <ButtonStats onClick={onClickChange}>{statsLinkText}</ButtonStats>
          </Stats>
        ) : null}
      </span>
      {openSidebar ? (
        sidebarTaskStatus ? (
          <Button
            disabled={sidebarCreate}
            className={sidebarCreate ? 'disabled-button' : ''}
            onClick={openSidebarAction}
          >
            {sidebarButtonText}
          </Button>
        ) : (
          <Button disabled={sidebarTaskStatus} className={'disabled-button'}>
            {sidebarButtonText}
          </Button>
        )
      ) : null}
      {sidebarComment ? (
        <Button onClick={sidebarComment}>Pogledaj komentar</Button>
      ) : null}

      {filter ? (
        <ul>
          {citiesFilter ? (
            <li>
              <ListBox
                isMulti
                options={cityOptions}
                onChange={(value) => handleOnChangeCities(value)}
                value={selectCityValue}
                placeholder="Kandidati po gradovima"
              />
            </li>
          ) : null}
          {search ? (
            <li>
              <FormInput
                defaultValue={defaultValueSearch}
                inputPlaceholder={inputPlaceHolderSearch}
                onInputChange={onInputChangeSearch}
                svgIcon={'#search'}
                icon={true}
              />
            </li>
          ) : null}
          {secondSearch ? (
            <li>
              <FormInput
                defaultValue={secondDefaultValueSearch}
                inputPlaceholder={secondInputPlaceHolderSearch}
                onInputChange={secondOnInputChangeSearch}
                svgIcon={'#search'}
                icon={true}
              />
            </li>
          ) : null}
          {thirdSearch ? (
            <li>
              <FormInput
                defaultValue={thirdDefaultValueSearch}
                inputPlaceholder={thirdInputPlaceHolderSearch}
                onInputChange={thirdOnInputChangeSearch}
                svgIcon={'#search'}
                icon={true}
              />
            </li>
          ) : null}
          <li>
            <Label>{labelFirstFilter}</Label>
            <Select
              options={optionsFilter}
              onSelectChange={(value) => onChange(value)}
              value={selectValue}
              defaultOption={defaultOption}
              defaultOptionLabel={defaultOptionText}
              defaultOptionDisabled={false}
              defaultOptionHidden={false}
              defaultOptionText={defaultOptionOriginal}
              resetButton={true}
              icon={'filters'}
            />
          </li>
          {secondFilter ? (
            <li>
              <Label>{labelSecondFilter}</Label>
              <Select
                options={optionsFilterSecond}
                onSelectChange={(value) => onChangeSecond(value)}
                value={selectSecondValue}
                defaultOption={defaultOptionSecond}
                defaultOptionLabel={defaultOptionTextSecond}
                defaultOptionDisabled={false}
                defaultOptionHidden={false}
                resetButton={true}
                icon={'filters'}
              />
            </li>
          ) : null}
          {ctaButton ? (
            <li>
              <Link to={route}>
                {linkIcon} {linkText}
              </Link>
            </li>
          ) : null}
        </ul>
      ) : null}
    </CandidateAppsHeadingSection>
  );
};

const CandidateAppsHeadingSection = styled(SubHeading)`
  justify-content: space-between;

  h2 {
    word-break: keep-all;
  }

  .loadOverlayAnimation {
    left: 100%;
    width: auto;
    margin-left: 12px;

    > div {
      width: 30px;
      height: 30px;
    }
  }

  label {
    margin-bottom: 0;
  }

  ul {
    background: none;
    padding: 0;
    margin: 0;

    li {
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        @media (max-width: 576px) {
          margin-bottom: 0;
        }
      }

      select {
        min-width: 200px;
      }
    }

    a,
    button {
      color: ${colors.PURPLE_COLOR};
      font-weight: 700;
      display: flex;
      align-items: center;

      &:hover {
        color: ${colors.TEXT_BLACK};

        svg {
          fill: ${colors.TEXT_BLACK};
        }
      }

      svg,
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
        fill: ${colors.PURPLE_COLOR};
        transition: fill 100ms ease-in-out;
      }
    }
  }

  .select-wrapper {
    /* width: 260px; */

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .filter-select__title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      flex: 0 0 100%;
      margin-bottom: 10px;
    }
  }
`;

const Stats = styled.span`
  margin-left: auto;

  @media (max-width: 576px) {
    flex: 0 0 100%;
    margin: 5px 0 0;
  }
`;
const ButtonStats = styled(Button)`
  display: flex;
  align-items: center;
`;

export default DashboardHeadingFilterSection;
